<div class="disp-flex-AlignCenter w-100">
  <div class="w-20">
    <div class="circle-snack">
      <mat-icon
        aria-hidden="false"
        fontSet="material-icons-outlined"
        aria-label="Example home icon"
        class="succ icons-navs-mat"
        >check
      </mat-icon>
    </div>
  </div>
  <div class="w-70">
    <div class="h-30px disp-flex align-items-center">
      <h1 class="ft-14px mb-0">Success</h1>
      <p class="ml-3 mb-0 mt-1 ft-10px">{{ now | date: 'shortTime' }}</p>
    </div>

    <p class="ft-12px">{{ data.message }}</p>
  </div>
  <div>
    <button class="btn-none" mat-raised-button (click)="snackBar.dismiss()">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 6L6 18"
          stroke="#828A9B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 6L18 18"
          stroke="#828A9B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</div>
